import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home, Features, Pricing, About, Contact, UseCases, UseCasePage } from "@/pages_marketing";
import { Blog, BlogPost, Compare, Vs, ResultPage } from "@/pages_seo";
import { Login, Signup, Dashboard, BulkPage, HistoryPage, ApiKeyPage, BillingPage } from "@/pages_app";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/use-cases" element={<UseCases />} />
        <Route path="/use-cases/:slug" element={<UseCasePage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/vs/:slug" element={<Vs />} />
        <Route path="/r/:id" element={<ResultPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/bulk" element={<BulkPage />} />
        <Route path="/dashboard/history" element={<HistoryPage />} />
        <Route path="/dashboard/api" element={<ApiKeyPage />} />
        <Route path="/dashboard/billing" element={<BillingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
